/* src/app/builder-screen-beta/components/webhook-adapter/webhook-adapter.component.scss */
.webhook-adapter {
  width: 100%;
}
.webhook-adapter ::ng-deep .ant-form-item {
  margin-bottom: 8px;
}
.webhook-adapter ::ng-deep .ant-form-item-label {
  padding-bottom: 2px;
}
.webhook-adapter ::ng-deep .preview-mode .ant-form-item {
  margin-bottom: 4px;
}
/*# sourceMappingURL=webhook-adapter.component.css.map */
